import environment from '@/helpers/environment';
import dataFetcher from './dataFetcher';
import userService from './user-service';
import type { AxiosError, AxiosResponse } from 'axios';
import axios from 'axios';
import monitoringService from './monitoring-service';
import dgService from './dataGravity/baseDataGravityService';
import { getApiImageURL } from './images';

export const API_BASE = environment.VITE_API_BASE;
export const APP_BASE = environment.VITE_APP_BASE;

export { dataFetcher, dgService, monitoringService, userService, getApiImageURL };

const getCookie = (name: string) => {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  return parts.length == 2 ? parts!.pop()!.split(';').shift() : null;
};

axios.interceptors.request.use((config) => {
  const csrfToken = getCookie('XSRF-TOKEN');
  if (csrfToken) {
    config.headers.common['X-XSRF-TOKEN'] = csrfToken;
  }

  return config;
});

axios.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    return response;
  },
  (error: AxiosError<any>) => {
    if (
      environment.VITE_APP_ENV !== 'local' &&
      (error.response?.status === 401 ||
        (error.response?.status !== 200 && error.response?.data.message === 'Expired JWT'))
    ) {
      window.location.href = `${APP_BASE}.auth/login/aad?post_login_redirect_uri=/`;
    }
    return Promise.reject(error);
  }
);
